import { isSet, isMap } from "../typeMatchers";

/**
 * Create a shallow clone of a given Object or Array
 * @private
 * @param  {Object|Array|Set|Map} instance Object or Array or Set or Map to clone
 * @return {Object|Array|Set|Map} (respectively) a shallow clone
 */
export function clone(
	instance: Record<string | symbol, any> | any[] | Set<any> | Map<any, any>,
): Record<string | symbol, any> | any[] | Set<any> | Map<any, any> {
	if (Array.isArray(instance)) {
		return Array.from(instance);
	} else if (isSet(instance)) {
		return new Set(instance as Set<any>);
	} else if (isMap(instance)) {
		return new Map(instance as Map<any, any>);
	}
	return Object.assign({}, instance);
}
